import type { FC } from 'react'

import { B16 } from '@rentspree/ssr-component-v2'
import styled from 'styled-components'

import { COLOR } from 'styles/constants'

const CheckBoxLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: center;
  align-items: center;
  height: 112px;
  background: ${COLOR.WHITE};
  border: 1px solid ${COLOR.GRAY_SCALE_20};
  border-radius: 4px;
  width: 88px;
  &:hover {
    border-color: ${COLOR.GRAY_SCALE_20};
    background: ${COLOR.GRAY_SCALE_15};
    cursor: pointer;
  }
  margin-right: 20px;
`

const Wrapper = styled.div`
  input[type='checkbox']:checked + label {
    background: ${COLOR.BLUE_10};
    border-color: ${COLOR.BLUE_LV4};
    &:hover {
      background: ${COLOR.BLUE_20};
    }
  }
  input[type='checkbox']:disabled + label {
    border-color: ${COLOR.GRAY_SCALE_20};
    background: ${COLOR.GRAY_SCALE_15};
    cursor: not-allowed;
    color: ${COLOR.GRAY_SCALE_30};
  }
`

type Props = {
  id: string
  name: string
  value: number | string
  onChange: React.ChangeEventHandler
  disabled: boolean
  title: string
  subtitle: string
  checked?: boolean
}

export const CheckBoxItem: FC<Props> = ({
  checked = false,
  title,
  subtitle,
  id,
  name,
  value,
  onChange,
  disabled,
  ...props
}) => (
  <Wrapper {...props}>
    <input
      id={id}
      checked={checked}
      name={name}
      value={value}
      type="checkbox"
      hidden
      disabled={disabled}
      onChange={onChange}
    />
    <CheckBoxLabel htmlFor={id}>
      <B16>{title}</B16>
      <B16 weight={700}>{subtitle}</B16>
    </CheckBoxLabel>
  </Wrapper>
)
